import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-6 text-gray-300 text-sm leading-relaxed" data-id="element-122">
    <h3 className="text-2xl font-bold text-white font-serif" data-id="element-123">
      Política de Privacidad
    </h3>
    <p className="text-gray-400 text-xs" data-id="element-124">Última actualización: Marzo 2026</p>

    <div className="space-y-4" data-id="element-125">
      <h4 className="text-lg font-semibold text-white" data-id="element-126">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-127">
        Recopilamos información personal que usted nos proporciona directamente
        al realizar una compra, incluyendo su nombre, dirección de correo
        electrónico y datos de pago. Los datos de pago son procesados de forma
        segura por nuestro procesador de pagos y no almacenamos información de
        tarjetas de crédito en nuestros servidores.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-128">
        2. Uso de la Información
      </h4>
      <p data-id="element-129">Utilizamos su información personal para:</p>
      <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-130">
        <li data-id="element-131">Procesar y entregar su compra</li>
        <li data-id="element-132">Enviar confirmaciones de pedido y actualizaciones</li>
        <li data-id="element-133">Proporcionar soporte al cliente</li>
        <li data-id="element-134">
          Enviar comunicaciones relacionadas con el producto (puede darse de
          baja en cualquier momento)
        </li>
      </ul>

      <h4 className="text-lg font-semibold text-white" data-id="element-135">
        3. Protección de Datos
      </h4>
      <p data-id="element-136">
        Implementamos medidas de seguridad técnicas y organizativas apropiadas
        para proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-137">
        4. Compartir Información
      </h4>
      <p data-id="element-138">
        No vendemos, intercambiamos ni transferimos su información personal a
        terceros. Esto no incluye terceros de confianza que nos ayudan a operar
        nuestro sitio web o a realizar nuestro negocio, siempre que esas partes
        acuerden mantener esta información confidencial.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-139">5. Cookies</h4>
      <p data-id="element-140">
        Nuestro sitio puede utilizar cookies para mejorar la experiencia del
        usuario. Puede configurar su navegador para rechazar cookies, aunque
        esto puede afectar la funcionalidad del sitio.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-141">6. Sus Derechos</h4>
      <p data-id="element-142">
        Usted tiene derecho a acceder, rectificar o eliminar sus datos
        personales en cualquier momento. Para ejercer estos derechos, puede
        contactarnos a través de los canales proporcionados.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-143">
        7. Cambios a Esta Política
      </h4>
      <p data-id="element-144">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con una
        fecha de actualización revisada.
      </p>
    </div>
  </div>;
const termsContent = <div className="space-y-6 text-gray-300 text-sm leading-relaxed" data-id="element-145">
    <h3 className="text-2xl font-bold text-white font-serif" data-id="element-146">
      Términos y Condiciones
    </h3>
    <p className="text-gray-400 text-xs" data-id="element-147">Última actualización: Marzo 2026</p>

    <div className="space-y-4" data-id="element-148">
      <h4 className="text-lg font-semibold text-white" data-id="element-149">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-150">
        Al acceder y realizar una compra en este sitio, usted acepta estar
        sujeto a estos términos y condiciones de uso. Si no está de acuerdo con
        alguna parte de estos términos, no debe utilizar nuestro sitio ni
        adquirir nuestros productos.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-151">2. Producto Digital</h4>
      <p data-id="element-152">
        "Rompe El Código Del Dinero" es un producto digital (ebook/guía) que se
        entrega en formato electrónico. Al completar su compra, recibirá acceso
        inmediato para descargar el material. Este es un producto educativo e
        informativo y los resultados pueden variar según cada persona.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-153">3. Precio y Pago</h4>
      <p data-id="element-154">
        El precio del producto es el indicado en la página de venta al momento
        de la compra. Todos los pagos se procesan de forma segura a través de
        nuestro procesador de pagos autorizado. Los precios están expresados en
        dólares estadounidenses (USD).
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-155">
        4. Garantía de Devolución
      </h4>
      <p data-id="element-156">
        Ofrecemos una garantía incondicional de devolución de dinero de 7 días a
        partir de la fecha de compra. Si por cualquier motivo no está satisfecho
        con el producto, puede solicitar un reembolso completo dentro de este
        período sin necesidad de justificación.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-157">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-158">
        Todo el contenido del producto, incluyendo textos, gráficos,
        metodologías y materiales, está protegido por derechos de autor. La
        compra le otorga una licencia personal e intransferible para uso
        individual. Queda prohibida la reproducción, distribución o reventa del
        material sin autorización expresa.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-159">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-160">
        Este producto tiene fines educativos e informativos. No constituye
        asesoramiento financiero, legal o profesional. Los resultados descritos
        son ilustrativos y no garantizamos resultados específicos. Usted es
        responsable de sus propias decisiones financieras.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-161">
        7. Descargo de Responsabilidad
      </h4>
      <p data-id="element-162">
        No somos asesores financieros certificados. La información proporcionada
        se basa en experiencias personales y estudios de desarrollo personal.
        Consulte con un profesional financiero antes de tomar decisiones
        importantes sobre su dinero.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-163">8. Modificaciones</h4>
      <p data-id="element-164">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio. El uso continuado del sitio después de
        dichos cambios constituye su aceptación de los nuevos términos.
      </p>
    </div>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-900 border-t border-gray-800/50 py-8 px-4" data-id="element-165">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-166">
          <div className="flex items-center gap-6" data-id="element-167">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-500 hover:text-gold transition-colors duration-200" data-id="element-168">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-169">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-500 hover:text-gold transition-colors duration-200" data-id="element-170">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-gray-600" data-id="element-171">
            © {new Date().getFullYear()} Rompe El Código Del Dinero. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-172">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-173">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-navy-800 border border-gray-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-174">
              <div className="flex items-center justify-between p-6 border-b border-gray-700/50" data-id="element-175">
                <h2 className="text-lg font-bold text-gold" data-id="element-176">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-navy-700 transition-colors" data-id="element-177">
                  <XIcon className="w-5 h-5" data-id="element-178" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-179">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}